import React, { useEffect, useState } from 'react';
import { Layout } from 'antd';
import mc from './MainContainer.module.scss';
import theme_css from '@/utils/themes/Themes.module.scss';
import Header from '@/widgets/Header/Header';
import Footer from '@/widgets/Footer/Footer';
import { Breadcrumb, Button, ConfigProvider, Flex, Typography } from 'antd';
import { IBreadcrumb } from 'tkmp-lib/src/interfaces';
import Link from 'next/link';
import { useStores } from '@/utils/hooks/useStores';
import { observer } from 'mobx-react-lite';

import dynamic from 'next/dynamic';
const ModalRegistrationForm = dynamic(
    () => import('@/components/MainContainer/ModalRegistrationForm'),
    {},
);
const DrawerLoginForm = dynamic(() => import('@/components/MainContainer/DrawerLoginForm'), {});
const ModalLocationForm = dynamic(() => import('@/components/MainContainer/ModalLocationForm'), {});
const ModalUnaccessedDescription = dynamic(
    () => import('@/components/MainContainer/ModalUnaccessedDescription'),
    {},
);
const ModalQuestionForm = dynamic(() => import('@/components/MainContainer/ModalQuestionForm'), {});

// import ModalRegistrationForm from '@/components/MainContainer/ModalRegistrationForm';
// import DrawerLoginForm from '@/components/MainContainer/DrawerLoginForm';
// import ModalLocationForm from '@/components/MainContainer/ModalLocationForm';
// import ModalUnaccessedDescription from '@/components/MainContainer/ModalUnaccessedDescription';
// import ModalQuestionForm from '@/components/MainContainer/ModalQuestionForm';
import { AuthService } from 'tkmp-lib/src/services/AuthService';
import useLocalization from 'tkmp-lib/src/hooks/useLocalization';

const MainContainer = observer(({ children }: { children: React.ReactNode }) => {
    const {
        modalsStore: {
            IS_LOGIN_OPEN,
            IS_REGISTER_OPEN,
            IS_LOCATION_OPEN,
            IS_UNACCESSED_OPEN,
            IS_QUESTION_FORM,
            closeLoginForm,
            closeRegisterForm,
            closeLocationForm,
            closeUnaccessedForm,
            closeQuestionForm,
        },
        systemStore: { BREADCRUMBS },
    } = useStores();

    const [isNewbie, setIsNewbie] = useState<boolean>(false);
    const LOCALIZATION = useLocalization();
    useEffect(() => {
        AuthService.init().then((answer) => {
            if (!answer) setIsNewbie(true);
        });
    }, []);
    return (
        <>
            <Layout className={`${mc.app} ${theme_css.GeneralContainer__Theme}`}>
                <Header />
                <Flex className={mc.wrapper_container}>
                    <Layout className={mc.container}>
                        {BREADCRUMBS.length > 0 && (
                            <Breadcrumb
                                className={mc.container__breadcrumbs}
                                items={BREADCRUMBS?.map((breadcrumb: IBreadcrumb) => ({
                                    key: breadcrumb.key,
                                    title: (
                                        <Link
                                            onClick={(e) =>
                                                breadcrumb?.disabled ? e.preventDefault() : {}
                                            }
                                            href={breadcrumb?.disabled ? {} : breadcrumb.key}
                                            style={{
                                                cursor: breadcrumb?.disabled
                                                    ? 'default'
                                                    : 'pointer',
                                            }}
                                        >
                                            {breadcrumb.title}
                                        </Link>
                                    ),
                                }))}
                            />
                        )}
                        {children}
                    </Layout>
                </Flex>
                <Footer />

                {isNewbie && (
                    <Layout className={mc.cookieMessage_wrapper}>
                        <Layout className={mc.cookieMessage_block}>
                            <Flex
                                vertical
                                gap={'8px'}
                            >
                                <Typography.Text
                                    className={`text-20-400`}
                                    style={{ color: '#FFFFFF' }}
                                >
                                    {LOCALIZATION.widgets.MainContainer.message}
                                </Typography.Text>
                                <Link
                                    href={''}
                                    className={`text-20-400`}
                                    style={{ color: '#DCFF00' }}
                                >
                                    {LOCALIZATION.widgets.MainContainer.link}
                                </Link>
                            </Flex>
                            <Button
                                onClick={() => setIsNewbie(false)}
                                style={{ width: '200px', height: '40px' }}
                                size={'large'}
                            >
                                {LOCALIZATION.widgets.MainContainer.button}
                            </Button>
                        </Layout>
                    </Layout>
                )}
                <ModalRegistrationForm
                    callback_open={IS_REGISTER_OPEN}
                    callback_close={closeRegisterForm}
                />
                <DrawerLoginForm
                    callback_open={IS_LOGIN_OPEN}
                    callback_close={closeLoginForm}
                />
                <ModalLocationForm
                    callback_open={IS_LOCATION_OPEN}
                    callback_close={closeLocationForm}
                />
                <ModalUnaccessedDescription
                    callback_open={IS_UNACCESSED_OPEN}
                    callback_close={closeUnaccessedForm}
                />
                <ModalQuestionForm
                    callback_open={IS_QUESTION_FORM}
                    callback_close={closeQuestionForm}
                />
            </Layout>
        </>
    );
});

export default MainContainer;
